import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import { NavLink } from "react-router-dom";

const Contact = () => {
  return (
    <>
      <section className="contact-hero">
        <Container>
          <h1>Contact</h1>
          <p>
            <NavLink to="/">Home</NavLink> <span>»</span> Contact
          </p>
        </Container>
      </section>

      {/* CONTENT */}
      <section className="contact-section">
        <Container>
          <Row className="align-items-center gy-5">
            {/* LEFT INFO */}
            <Col lg={5}>
              <Row className="g-4">
                <Col md={6}>
                  <div className="info-box">
                    {/* <FaPhoneAlt /> */}
                    <h5>For any Query?</h5>
                    <p>+91 7022289866</p>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="info-box">
                    {/* <FaMapMarkerAlt /> */}
                    <h5>Visit anytime</h5>
                    <p>
                      No.202 , 3rd floor, 301 6th cross, aswath nagar,
                      Marathahalli Bangalore 560037
                    </p>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="info-box">
                    {/* <FaEnvelope /> */}
                    <h5>Write email Us</h5>
                    <p>hr@coresemicon.com</p>
                  </div>
                </Col>
              </Row>
            </Col>

            {/* RIGHT FORM */}
            <Col lg={7}>
              <div className="contact-form">
                <span className="form-subtitle">Send us email</span>
                <h2>Feel Free to write</h2>

                <Form>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Control placeholder="Enter Name" />
                    </Col>
                    <Col md={6}>
                      <Form.Control placeholder="Enter Email" />
                    </Col>
                    <Col md={6}>
                      <Form.Control placeholder="Enter Subject" />
                    </Col>
                    <Col md={6}>
                      <Form.Control placeholder="Enter Phone" />
                    </Col>
                    <Col md={12}>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Enter Message"
                      />
                    </Col>
                    <Col md={12}>
                      <Button className="send-btn">Send Message</Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;
